import React from "react";
import SendIcon from '../../assets/images/send-icon.png';
import moment from "moment/moment";
import TimeAgo from "timeago-react";

export function ZoomChatBox({ currentUser, sessionChat, chatInput, handleSendMsg, show }) {
    return (
        <div className="chat-sidebar" style={show ? {} : { position: "absolute", left: "-1000px" }}>
            <div className="individual-chart-wrap">
                <div className="chat-body">
                    {sessionChat?.map(({
                        id, sender: {
                            userId, name
                        }, timestamp, message
                    }) => <div className={`msg-common ${userId === currentUser.userId ? "sender" : "receiver"}`} key={id}>
                            <div className="msg-text">
                                {message}
                            </div>
                            <p className="msg-time">
                                {userId === currentUser.userId ? "" : name + ", "}
                                <TimeAgo datetime={moment(timestamp)} />
                            </p>
                        </div>)}
                </div>
                <div className="msg-footer">
                    <form className="search-wrap" onSubmit={handleSendMsg}>
                        <input ref={chatInput} className="form-control me-2" type="search" placeholder="Type something" aria-label="Search" />
                        <button type="submit" title="Send"><img src={SendIcon} alt="Send" /></button>
                    </form>
                </div>
            </div>
        </div>
    );
}
